import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./LandingPage.css";
import demoDashboard from "../../images/chart_active.png";
import { motion } from "framer-motion";
import Login from "../../components/Login/Login";
import Signup from "../../components/Signup/Signup";
import ModalWrapper from "../../components/ModalWrapper";
import Slider from "../../components/Slider/Slider";

export default function LandingPage() {
  useEffect(() => { AOS.init({ duration: 900, once: true, offset: 80, disable: function () {
    return window.innerWidth < 900;
  } }); }, []);
  const [loginOpen, setLoginOpen] = useState(false);
  const [signupOpen, setSignupOpen] = useState(false);

  // Blokowanie scrolla gdy modal otwarty
  useEffect(() => {
    if (loginOpen || signupOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [loginOpen, signupOpen]);

  return (
    <div className="lp-root">
      <header className="lp-header" data-aos="fade-down" data-aos-delay="150">
        <span className="lp-logo">ML Strategy</span>
        <nav className="lp-nav">
          <a href="#features">Jak to działa?</a>
          <a href="#footer">Kontakt</a>
          <button className="lp-login-btn" onClick={() => setLoginOpen(true)}>
            Zaloguj się
          </button>
        </nav>
      </header>

      <section className="lp-hero" data-aos="fade-up">
        <div className="lp-hero-left">
          <h1 data-aos="fade-right" data-aos-delay="200">
            <span className="lp-hero-accent">Sztuczna Inteligencja<br /></span>
            dla Twoich inwestycji
          </h1>
          <p data-aos="fade-right" data-aos-delay="350">
            Nowoczesne, wielopoziomowe strategie ML do zarządzania kapitałem na rynkach krypto — <b>bez kompromisów</b>.
            Przetestowane algorytmy. Prawdziwe wyniki. Zero przypadków.
          </p>
          <button
            className="lp-main-btn"
            data-aos="zoom-in"
            data-aos-delay="500"
            onClick={() => setSignupOpen(true)}
          >
            Rozpocznij darmowy okres próbny
          </button>
        </div>
        <div className="lp-hero-right" data-aos="zoom-in-left" data-aos-delay="700">
          <img src={demoDashboard} alt="ML Strategy Demo" />
        </div>
      </section>

      <section id="features" className="lp-section" data-aos="fade-up" data-aos-delay="200">
        <h2 data-aos="flip-down" data-aos-delay="100">Kluczowe cechy ML Strategy</h2>
        <div className="lp-features">
          <div data-aos="fade-right" data-aos-delay="300">
            <h3>Automatyczne strategie</h3>
            <p>
              W pełni automatyczne zarządzanie pozycjami na wielu rynkach jednocześnie.
              Dedykowane algorytmy ML reagują na zmiany rynku 24/7.
            </p>
          </div>
          <div data-aos="fade-up" data-aos-delay="450">
            <h3>Zaawansowane statystyki</h3>
            <p>
              Wyniki, wykresy ROI, skuteczność strategii — pełna transparentność.
              Śledź efekty swojego kapitału w czasie rzeczywistym.
            </p>
          </div>
          <div data-aos="fade-left" data-aos-delay="600">
            <h3>Bezpieczeństwo & Prywatność</h3>
            <p>
              Szyfrowanie danych, ochrona kapitału, brak kompromisów co do bezpieczeństwa
              Twoich środków i informacji.
            </p>
          </div>
        </div>
      </section>

      <Slider />

      <section className="lp-section lp-cta" data-aos="fade-up" data-aos-delay="200">
        <h2 data-aos="zoom-in" data-aos-delay="200">Dołącz do grona profesjonalistów</h2>
        <p data-aos="fade-up" data-aos-delay="400">
          Zaufaj technologii, która przynosi realne rezultaty.<br />
          Zyskaj przewagę na rynku dzięki narzędziom klasy premium.
        </p>
        <button
          onClick={() => setSignupOpen(true)}
          className="lp-main-btn"
          data-aos="flip-left"
          data-aos-delay="600"
        >
          Wypróbuj za darmo
        </button>
      </section>
<section id="footer">
<motion.footer
  className="lp-footer"
  initial={{ opacity: 0, y: 32 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ delay: 0.6, duration: 1.1 }}
>
  &copy; {new Date().getFullYear()} ML Strategy. Wszystkie prawa zastrzeżone. Kontakt: wojciech.wnukk@gmail.com
</motion.footer>
</section>
    <ModalWrapper open={loginOpen} onClose={() => setLoginOpen(false)}>
  <Login onSwitchToSignup={() => { setLoginOpen(false); setSignupOpen(true); }} onClose={() => setLoginOpen(false)} />
</ModalWrapper>
<ModalWrapper open={signupOpen} onClose={() => setSignupOpen(false)}>
  <Signup onSwitchToLogin={() => { setSignupOpen(false); setLoginOpen(true); }} onClose={() => setSignupOpen(false)} />
</ModalWrapper>
    </div>
  );
}
